import { authenticatedGet, authenticatedPost, authenticatedPut, authenticatedDelete } from "../../api/authenticatedFetch";

const BASE = "/api/v1/taxonomy";

export const getProviderMappings = async () => authenticatedGet(`${BASE}/provider-mappings`);
export const getClassificationCoverage = async () => authenticatedGet(`${BASE}/classification-coverage`);
export const createMappingOverride = async (payload) => authenticatedPost(`${BASE}/provider-mappings/overrides`, payload);
export const deleteMappingOverride = async (id) => authenticatedDelete(`${BASE}/provider-mappings/overrides/${id}`);
export const updateMappingOverride = async (id, payload) => authenticatedPut(`${BASE}/provider-mappings/overrides/${id}`, payload);
